import * as React from 'react';

export type TSnackbarMessageLevel = 'info' | 'warning' | 'error';

export interface ISnackbarContext {
  spawn: (message: string, level?: TSnackbarMessageLevel, onClose?: () => void) => undefined | void;
}

export const SnackbarContext = React.createContext<ISnackbarContext>({
  spawn: (_message: string, _level = 'info' as TSnackbarMessageLevel, _onClose?: () => void) => undefined,
});
